import { render, staticRenderFns } from "./TagLegal.vue?vue&type=template&id=0ea4e0c2&"
import script from "./TagLegal.vue?vue&type=script&lang=js&"
export * from "./TagLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports